export enum ErrorType {
  FETCH = 'fetch',
  FETCH_TRANSLATIONS = 'fetch_translations',
  FETCH_USER = 'fetch_user',
  UNKNOWN = 'unknown'
}
